export default {
  GET_CONTRACTS(state) {
    return state.contracts
  },
  GET_CONTRACTS_V2(state) {
    return state.contractList
  },
  GET_ONE_CONTRACT(state) {
    const {
      customer,
      ...rest
    } = state.single_contract
    return {
      customer_details: customer,
      customer: customer.id,
      ...rest,
    }
  },
  GET_CONTRACT_HISTORY(state) {
    return state.contract_history
  },
  GET_CONTRACT_TEMPLATES(state) {
    return state.contract_templates
  },
  GET_CONTRACT_TEMPLATES_FILE(state) {
    return state.contract_templates_file
  },
  GET_ONE_CONTRACT_TEMPLATE(state) {
    return state.single_contract_template
  },
  GET_ONE_CONTRACT_TEMPLATE_FILE(state) {
    return state.single_contract_template_file
  },
  GET_CONTRACT_TEMPLATE_FIELDS(state) {
    return state.contract_template_fields
  },
}